export default __webpack_public_path__ + "748744a396e02e990e54d6aac9c021ce.webp";